import { RouteConfig } from 'vue-router';
import SnbServiceCoterm from './snb-service-coterm.vue';
import TermsOfService from './components/tos.vue';
export const SnbCoTermRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'cotermnew',
  component: SnbServiceCoterm,
};

export const TermsOfServiceRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'tos',
  component: TermsOfService,
};
